var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.824 7.488l-5.062-5.062a.596.596 0 00-.809 0 .596.596 0 000 .808l4.113 4.079H6.188a.578.578 0 00-.563.562c0 .316.246.563.563.563h9.878l-4.113 4.113a.596.596 0 000 .808c.211.211.598.211.809 0l5.062-5.062A.582.582 0 0018 7.875c0-.14-.07-.281-.176-.387zM6.187 14.625H2.813c-.949 0-1.687-.738-1.687-1.688V2.813c0-.915.738-1.688 1.688-1.688h3.374A.578.578 0 006.75.562C6.75.282 6.469 0 6.187 0H2.813A2.798 2.798 0 000 2.813v10.124a2.777 2.777 0 002.813 2.813h3.374a.578.578 0 00.563-.563c0-.28-.281-.562-.563-.562z",
    fill: "#fff"
  })));
}
export default SvgExitWhite;